import _objectSpread from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { mapState, mapActions } from "vuex";
import helper from "@/libs/helper.js";
import axios from "@/plugin/axios";
import constValues from "@/libs/constValues";
export default {
  computed: _objectSpread({}, mapState("d2admin/user", ["info"])),
  data: function data() {
    return {
      version: constValues.version
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/account", ["logout"])), {}, {
    /**
     * @description 登出
     */
    logOff: function logOff() {
      this.logout({
        confirm: true
      });
    },
    /**
     * 修改密码
     */
    changePwd: function changePwd() {
      this.$router.push({
        path: "/change_pwd"
      });
    }
  })
};